const Menu = [
  { is_header: true, title: "Dashboard" },
  { path: "/dashboard", icon: "bi bi-cpu", title: "Readiness" },
  { path: "/kpi", icon: "bi bi-bar-chart", title: "Performance" },
  {
    path: "/manpower",
    icon: "far fa-user",
    title: "Manpower",
    children: [
      { path: "/manpower/dashboard", title: "Dashboard" },
      { path: "/manpower/data", title: "Data" },
      { path: "/manpower/new", title: "New" },
    ],
  },
  { is_divider: true },
  { is_header: true, title: "Activity" },
  {
    path: "/training",
    icon: "fas fa-book",
    title: "Training",
    children: [
      { path: "/training/dashboard", title: "Dashboard" },
      { path: "/training/atmp", title: "ATMP" },
      { path: "/training/plan/data", title: "Plan & Mon." },
      { path: "/training/data", title: "Record" },
      { path: "/training/report/event", title: "Reporting" },
    ],
  },
  {
    path: "/mentoring",
    icon: "far fa-hand-point-right",
    title: "Mentoring",
    children: [
      { path: "/mentoring/data", title: "Data" },
      { path: "/mentoring/report/event", title: "Reporting" },
    ],
  },
  {
    path: "/other-activity",
    icon: "far fa-check-square",
    title: "Other",
    children: [{ path: "/other-activity/data", title: "Data" }],
  },
  { is_divider: true },
  { is_header: true, title: "Documents" },
  {
    path: "/question",
    icon: "far fa-lightbulb",
    title: "Questions",
    children: [
      { path: "/question/data", title: "Data" },
      { path: "/question/event", title: "Event" },
    ],
  },
  {
    path: "/training-evaluation",
    icon: "far fa-comments",
    title: "TEL Level 1",
    children: [{ path: "/training-evaluation/event", title: "Event" }],
  },
  {
    path: "/training-evaluation-3",
    icon: "fas fa-bomb",
    title: "TEL Level 3",
    children: [{ path: "/training-evaluation-3/data", title: "Data" }],
  },
  {
    path: "/regulations",
    icon: "fas fa-gavel",
    title: "Regulations",
    children: [
      { path: "/regulations/sop", title: "SOP/INK/STD..." },
      // { path: "/regulations/jsa", title: "JSA" },
    ],
  },
  { is_divider: true },
  { is_header: true, title: "Messages" },
  {
    path: "/whatsapp",
    icon: "fab fa-whatsapp",
    title: "Whatsapp",
    children: [{ path: "/whatsapp/outgoing", title: "Outgoing" }],
  },
];

export default Menu;
